import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../store/modules/users/selectors';
import { Guard } from '../utility/guard';

const useGuard = (guard: Guard) => {
  const { data: user } = useSelector(selectCurrentUser);
  return Boolean(user && guard(user));
};

export default useGuard;
